import { WHATSAPP_NUMBER, WHATSAPP_MESSAGE } from "@/lib/data";

/** Build a WhatsApp click-to-chat URL with an optional custom message. */
export function waLink(customMessage) {
  const msg = encodeURIComponent(customMessage || WHATSAPP_MESSAGE);
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${msg}`;
}
